import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReturnFetchActionsByProduct } from '../../types/actionSchema';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { FetchActionsByProductQueryDto } from '../api.dto';

export const fetchActionsByProduct = createAsyncThunk<ReturnFetchActionsByProduct, FetchActionsByProductQueryDto, { rejectValue: string }>(
  'newActions/fetchActionsByProduct',
  async ({ productRN, regionId, part }) => {
    return await MyAxios.get(`/api/products/${productRN}/actions?part=${part}&regionId=${regionId}`)
      .then(handleResponse)
      .catch(error => handleError(error, []));
  },
);
